var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1429 12.1335C8.1429 12.8592 7.55522 13.4466 6.83139 13.4466C6.10756 13.4466 5.51988 12.8592 5.51988 12.1335C5.51988 11.4078 6.10756 10.8204 6.83139 10.8204C7.55522 10.8204 8.1429 11.4078 8.1429 12.1335Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7667 4.81906C20.7667 5.54476 20.179 6.13216 19.4552 6.13216C18.7313 6.13216 18.1437 5.54476 18.1437 4.81906C18.1437 4.09336 18.7313 3.50596 19.4552 3.50596C20.179 3.50596 20.7667 4.09336 20.7667 4.81906Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4078 19.1159C28.4078 19.8416 27.8201 20.429 27.0963 20.429C26.3725 20.429 25.7848 19.8416 25.7848 19.1159C25.7848 18.3902 26.3725 17.8028 27.0963 17.8028C27.8201 17.8028 28.4078 18.3902 28.4078 19.1159Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4547 25.4323C14.4547 26.158 13.867 26.7454 13.1432 26.7454C12.4193 26.7454 11.8316 26.158 11.8316 25.4323C11.8316 24.7066 12.4193 24.1192 13.1432 24.1192C13.867 24.1192 14.4547 24.7066 14.4547 25.4323Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36035 19.285V18.7701C4.36035 16.7141 5.09866 13.9246 7.15248 14.0206V14.0206C9.08875 14.1112 9.62258 16.6326 9.62258 18.571V19.285",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2004 11.3856V11.3856C16.2004 9.03233 17.3005 6.06207 19.6531 6.12003V6.12003C21.9288 6.17611 22.7782 8.96704 22.7782 11.2434V11.3856",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0938 25.868V25.3531C24.0938 23.2971 24.8321 20.5076 26.8859 20.6036V20.6036C28.8222 20.6942 29.356 23.2156 29.356 25.154V25.868",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62256 32.452V32.452C9.62256 30.0987 10.7226 27.1285 13.0752 27.1864V27.1864C15.3509 27.2425 16.2003 30.0335 16.2003 32.3099V32.452",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0033 7.16964C25.0033 10.2954 22.4716 12.8284 19.3496 12.8284C16.2277 12.8284 13.6959 10.2954 13.6959 7.16964C13.6959 4.04387 16.2277 1.51085 19.3496 1.51085C22.4716 1.51085 25.0033 4.04387 25.0033 7.16964Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3793 14.4841C12.3793 17.6099 9.84756 20.1429 6.7256 20.1429C3.60363 20.1429 1.07188 17.6099 1.07188 14.4841C1.07188 11.3583 3.60363 8.8253 6.7256 8.8253C9.84756 8.8253 12.3793 11.3583 12.3793 14.4841Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6442 21.4665C32.6442 24.5923 30.1125 27.1253 26.9905 27.1253C23.8685 27.1253 21.3368 24.5923 21.3368 21.4665C21.3368 18.3407 23.8685 15.8077 26.9905 15.8077C30.1125 15.8077 32.6442 18.3407 32.6442 21.4665Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6913 27.7829C18.6913 30.9087 16.1596 33.4417 13.0376 33.4417C9.91565 33.4417 7.38389 30.9087 7.38389 27.7829C7.38389 24.6572 9.91565 22.1241 13.0376 22.1241C16.1596 22.1241 18.6913 24.6572 18.6913 27.7829Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3767 10.1616L13.37 8.49923M22.838 12.3227L25.3296 15.4813M21.177 23.7932L18.8515 25.4556M12.8717 15.4813L15.3633 17.3099M6.72576 8.16675V6.17188M25.6618 7.66803L28.8178 9.33042M6.72576 28.1155H5.0647M19.3498 28.7804L22.838 30.4428",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.06065 4.17749C8.06065 4.91615 7.46247 5.51405 6.72569 5.51405C5.98891 5.51405 5.39073 4.91615 5.39073 4.17749C5.39073 3.43883 5.98891 2.84092 6.72569 2.84092C7.46247 2.84092 8.06065 3.43883 8.06065 4.17749Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3592 18.4734C18.3592 19.2121 17.7611 19.81 17.0243 19.81C16.2875 19.81 15.6893 19.2121 15.6893 18.4734C15.6893 17.7347 16.2875 17.1368 17.0243 17.1368C17.7611 17.1368 18.3592 17.7347 18.3592 18.4734Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0001 31.4402C26.0001 32.1788 25.4019 32.7768 24.6651 32.7768C23.9284 32.7768 23.3302 32.1788 23.3302 31.4402C23.3302 30.7015 23.9284 30.1036 24.6651 30.1036C25.4019 30.1036 26.0001 30.7015 26.0001 31.4402Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.40636 28.116C4.40636 28.8546 3.80818 29.4525 3.0714 29.4525C2.33461 29.4525 1.73643 28.8546 1.73643 28.116C1.73643 27.3773 2.33461 26.7794 3.0714 26.7794C3.80818 26.7794 4.40636 27.3773 4.40636 28.116Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6476 10.4949C31.6476 11.2335 31.0494 11.8314 30.3126 11.8314C29.5758 11.8314 28.9776 11.2335 28.9776 10.4949C28.9776 9.75621 29.5758 9.15831 30.3126 9.15831C31.0494 9.15831 31.6476 9.75621 31.6476 10.4949Z",
    stroke: "#2B5CAA",
    strokeWidth: 1.31661
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiUsers);
export default __webpack_public_path__ + "static/media/multi-users.5a0f9a1559a3cf6120f3c38a08d472ce.svg";
export { ForwardRef as ReactComponent };